import React, { useState } from "react";

const employerFAQs = [
    {
        question: "How do I post a job?",
        answer: "From your employer dashboard, click 'Add Job' and fill in the job details including title, description, location, and requirements. Once you're ready, publish the job to make it visible to candidates."
    },
    {
        question: "What is a Superstar Target?",
        answer: "A Superstar Target is someone who excels in the role you're hiring for — ideally someone you've worked with directly. The CareerMission system uses their personality profile to score and rank candidates based on career personality alignment."
    },
    {
        question: "How does candidate matching work?",
        answer: "Candidates complete a personality assessment that builds a career personality profile. The system then scores each candidate by comparing their profile against your Superstar Target's profile. Match scores and detailed breakdowns appear on your employer dashboard."
    },
    {
        question: "How do I invite candidates to apply?",
        answer: "From the job post page, copy the application link and share it directly with candidates via email, LinkedIn, or any other channel. Candidates who follow the link can apply and complete the assessment."
    },
    {
        question: "Can I add hiring managers and recruiters?",
        answer: "Yes. Company Admins can invite team members from the employer dashboard. Invited users receive an email to set up their account and gain access to your company's job posts and candidate data."
    },
    {
        question: "How much does Career Mission cost?",
        answer: "Visit our Pricing page for current plans, credit packages, and feature details. We offer flexible options to fit teams of all sizes."
    }
];

const candidateFAQs = [
    {
        question: "What does the assessment measure?",
        answer: "The CareerMission Personality Inventory measures key personality traits, motivations, and work style preferences. It builds a comprehensive career personality profile that employers use to evaluate fit for their open roles."
    },
    {
        question: "How long does the assessment take?",
        answer: "The assessment takes approximately 15–20 minutes to complete. Find a quiet moment where you can answer honestly and without interruption for the most accurate results."
    },
    {
        question: "Can I retake the assessment?",
        answer: "Assessment results are final to ensure consistency in matching. This prevents results from shifting based on mood or context, which keeps the matching accurate and fair for all candidates."
    },
    {
        question: "How does matching work?",
        answer: "Your match score is computed by comparing your personality profile to the employer's Superstar Target profile. Higher scores indicate stronger career personality alignment with the type of person who has excelled in that role."
    },
    {
        question: "What happens after I complete the assessment?",
        answer: "Your results become available to employers who have active job posts you've applied to. You can also view your own match results from your candidate dashboard to see how you align with each role."
    },
    {
        question: "How do I update my profile?",
        answer: "Click the profile icon in the header navigation to access your profile page. From there you can update your personal details and contact information."
    }
];

const FAQ = () => {
    const [activeTab, setActiveTab] = useState("employer");
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = activeTab === "employer" ? employerFAQs : candidateFAQs;

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        setOpenIndex(null);
    };

    const handleAccordionClick = (i) => {
        setOpenIndex(openIndex === i ? null : i);
    };

    return (
        <div className="min-h-screen bg-darkblue text-lightgray px-6 py-16">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl text-orange text-center mb-8">
                    Frequently Asked Questions
                </h1>

                {/* Tab toggle */}
                <div className="flex justify-center gap-4 mb-10">
                    <button
                        onClick={() => handleTabClick("employer")}
                        className={`px-6 py-2 rounded font-semibold transition-colors ${
                            activeTab === "employer"
                                ? "bg-orange text-darkblue"
                                : "bg-bluegray text-lightgray"
                        }`}
                    >
                        For Employers
                    </button>
                    <button
                        onClick={() => handleTabClick("candidate")}
                        className={`px-6 py-2 rounded font-semibold transition-colors ${
                            activeTab === "candidate"
                                ? "bg-orange text-darkblue"
                                : "bg-bluegray text-lightgray"
                        }`}
                    >
                        For Candidates
                    </button>
                </div>

                {/* Accordion */}
                <div className="space-y-3">
                    {faqs.map((faq, i) => (
                        <div key={i} className="border border-gray-600 rounded">
                            <button
                                onClick={() => handleAccordionClick(i)}
                                className="w-full text-left px-5 py-4 font-semibold text-lg flex justify-between items-center hover:text-orange transition-colors"
                            >
                                <span>{faq.question}</span>
                                <span className="ml-4 text-xl">{openIndex === i ? "−" : "+"}</span>
                            </button>
                            {openIndex === i && (
                                <div className="px-5 pb-4 text-gray-300">
                                    {faq.answer}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FAQ;
